// src/presentation/pages/ClinicalExamination/sections/OnsetPattern.tsx
import React from "react";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

interface OnsetPatternProps {
  value: "gradual" | "sudden" | "stepwise" | null;
  onChange: (value: "gradual" | "sudden" | "stepwise") => void;
}

export const OnsetPattern: React.FC<OnsetPatternProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <CardHeader className="pb-3 !px-0">
        <CardTitle className="text-base font-semibold text-gray-900">
          {t("clinicalSections.onsetPattern.title")}
        </CardTitle>
        <p className="text-sm text-gray-500">
          {t("clinicalSections.onsetPattern.question")}
        </p>
      </CardHeader>
      <CardContent className=" !px-0">
        <RadioGroup
          value={value || undefined}
          onValueChange={(val) =>
            onChange(val as "gradual" | "sudden" | "stepwise")
          }
          className="space-y-3"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="gradual" id="gradual" />
            <Label
              htmlFor="gradual"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.onsetPattern.gradual")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="sudden" id="sudden" />
            <Label
              htmlFor="sudden"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.onsetPattern.sudden")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="stepwise" id="stepwise" />
            <Label
              htmlFor="stepwise"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.onsetPattern.stepwise")}
            </Label>
          </div>
        </RadioGroup>
      </CardContent>
    </div>
  );
};
